export const LinkText = {
    fccLicenseApplication: 'FCC License Application',
} as const;
